import { Environment as r } from "./environment.es.js";
const t = r.env === "development" || r.env === "staging" || !!globalThis.__CI__, n = (o, e) => {
  t && console[o](...e);
}, g = {
  log(...o) {
    n("log", o);
  },
  warn(...o) {
    n("warn", o);
  },
  error(...o) {
    n("error", o);
  }
};
export {
  g as Debug
};
